import { Children } from 'react';

/** Returns whether the ReactNode has props (and therefore is an `Element` versus primitive type) */
function isChildWithProps(child) {
  return !!child && typeof child === 'object' && 'props' in child && child.props != null;
}

/**
 * Returns children and grandchildren of type ReactNode.
 * Flattens children one level to support Fragments and Array type children.
 */
export default function getChildrenAndGrandchildrenWithProps(children) {
  return Children.toArray(children).flatMap(child => {
    if (isChildWithProps(child) && child.props.children) {
      return child.props.children;
    }
    return child;
  }).filter(child => isChildWithProps(child));
}